import { render, staticRenderFns } from "./Partner.vue?vue&type=template&id=43f4a954&scoped=true"
import script from "../script/partner.js?vue&type=script&lang=js&external"
export * from "../script/partner.js?vue&type=script&lang=js&external"
import style0 from "./Partner.vue?vue&type=style&index=0&id=43f4a954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f4a954",
  null
  
)

export default component.exports